// Modul zur Zurordnung einer Terminreihe zum Antrag
"use strict";

import module from "./module";

export default module;
